@if ($hasAttachments()) {
  <div class="attachments">
    @for (tile of $attachments(); track tile.id) {
      @if (tile.isThumbnail) {
        <attachment class="tile" [attachment]="tile.attachment" [downloadable]="false" [selectable]="false" [deletable]="false" [thumbnailHeight]="80" (itemClicked)="onAttachmentClick($event)" />
      } @else {
        <div class="tile file" [title]="tile.name">
          <i class="file-chip-icon {{ tile.icon }}"></i>
          <div class="file-chip-meta">
            <span class="file-chip-name">{{ tile.name }}</span>
            <span class="file-chip-sub">File</span>
          </div>
        </div>
      }
    }
  </div>
}

@if ($textContent()) {
  <div class="bubble" [class.expanded]="$isExpanded()">
    <p class="text" #textEl [class.clamped]="!$isExpanded()">{{ $textContent() }}</p>
    @if ($overflows()) {
      <button type="button" class="show-toggle" (click)="onToggleExpand()">
        {{ $isExpanded() ? 'Show less' : 'Show more' }}
        <i class="fa-solid" [class.fa-chevron-down]="!$isExpanded()" [class.fa-chevron-up]="$isExpanded()"></i>
      </button>
    }
  </div>
}

@if ($copyable() && $textContent()) {
  <agent-message-actions [text]="$textContent()" />
}
